import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

const API_BASE = process.env.REACT_APP_API_URL || 'https://app.serpfinity.ai/api';

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('Verifying your email...');
    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('No verification token provided.');
            return;
        }

        const verifyEmail = async () => {
            try {
                const response = await fetch(`${API_BASE}/auth/verify-email`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token })
                });
                const data = await response.json();
                if (response.ok) {
                    setStatus('success');
                    setMessage('Your email has been verified successfully!');
                } else {
                    setStatus('error');
                    setMessage(data.message || 'Verification failed. The link may have expired or already been used.');
                }
            } catch (err) {
                setStatus('error');
                setMessage('Unable to verify email. Please try again later.');
            }
        };

        verifyEmail();
    }, [token]);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #0f0c29, #1a1a2e, #16213e)',
            padding: '20px'
        }}>
            <div style={{
                background: 'rgba(26, 26, 46, 0.95)',
                borderRadius: '16px',
                padding: '48px',
                maxWidth: '480px',
                width: '100%',
                textAlign: 'center',
                border: '1px solid rgba(139, 92, 246, 0.3)',
                boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
            }}>
                <h1 style={{ color: '#8b5cf6', fontSize: '28px', marginBottom: '8px' }}>SERPfinity</h1>
                <p style={{ color: '#94a3b8', fontSize: '14px', marginBottom: '32px' }}>AI-Powered SEO Platform</p>

                {status === 'verifying' && (
                    <div>
                        <div style={{
                            width: '48px', height: '48px', border: '4px solid rgba(139,92,246,0.3)',
                            borderTopColor: '#8b5cf6', borderRadius: '50%',
                            animation: 'spin 1s linear infinite', margin: '0 auto 24px'
                        }} />
                        <p style={{ color: '#cbd5e1', fontSize: '18px' }}>{message}</p>
                    </div>
                )}

                {status === 'success' && (
                    <div>
                        <CheckCircleIcon style={{ width: '64px', height: '64px', color: '#22c55e', margin: '0 auto 16px' }} />
                        <h2 style={{ color: '#ffffff', fontSize: '22px', marginBottom: '12px' }}>Email Verified!</h2>
                        <p style={{ color: '#cbd5e1', fontSize: '16px', lineHeight: '1.6', marginBottom: '32px' }}>{message}</p>
                        <button onClick={() => navigate('/login')} style={{
                            background: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
                            color: '#fff', border: 'none', padding: '14px 32px',
                            borderRadius: '8px', fontSize: '16px', fontWeight: 'bold',
                            cursor: 'pointer', width: '100%'
                        }}>
                            Log In to Your Account
                        </button>
                    </div>
                )}

                {status === 'error' && (
                    <div>
                        <XCircleIcon style={{ width: '64px', height: '64px', color: '#ef4444', margin: '0 auto 16px' }} />
                        <h2 style={{ color: '#ffffff', fontSize: '22px', marginBottom: '12px' }}>Verification Failed</h2>
                        <p style={{ color: '#cbd5e1', fontSize: '16px', lineHeight: '1.6', marginBottom: '32px' }}>{message}</p>
                        <button onClick={() => navigate('/login')} style={{
                            background: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
                            color: '#fff', border: 'none', padding: '14px 32px',
                            borderRadius: '8px', fontSize: '16px', fontWeight: 'bold',
                            cursor: 'pointer', width: '100%'
                        }}>
                            Go to Login
                        </button>
                    </div>
                )}

                <p style={{ color: '#64748b', fontSize: '13px', marginTop: '32px' }}>
                    Need help? Contact us at <a href="mailto:info@serpfinity.ai" style={{ color: '#8b5cf6' }}>info@SERPfinity.ai</a>
                </p>
            </div>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
}
